import React, { useEffect, useReducer, useState } from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import { withSitecoreContext, mediaApi} from '@sitecore-jss/sitecore-jss-react';
import { withRouter } from 'react-router-dom';
import GeneralNavigation from '../../react/GeneralNavigation/index';
import { handleResizeFixedHeader } from '../../ts/handleResizeFixedHeader';
import css from './index.module.scss';
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { Sizes, Colors } from '../../ts/enums';
import GeneralBrandbar from '../../react/GeneralBrandbar';

const ToggleMobileNav = () => {
  let header = document.querySelector('header[data-mobilenavisopen');
  let currentState = header.getAttribute('data-mobilenavisopen') === 'true';
  // @ts-ignore
  header.setAttribute('data-mobilenavisopen', !currentState);
  if (typeof window !== 'undefined' && window.innerWidth <= 900) {
    let currentBodyState = document.body.getAttribute('data-mobilenavopen') === 'true';
    // @ts-ignore
    document.body.setAttribute('data-mobilenavopen', !currentBodyState);
  }
}

const HandleScroll = () => {
  window.addEventListener('scroll', function () {
    let header = document.body.querySelector('header[data-scrolldown]');
    let elementAfterHeader = header.nextElementSibling || header.parentElement.nextElementSibling;
    let elBoundingTop = elementAfterHeader?.getBoundingClientRect()?.top;

    if (elBoundingTop < -80) {
      // Desktop and user has scrolled more than 80 pixels down, 80 is arbitrary - looks nice
      header.setAttribute('data-scrolldown', 'true');
    }
    else {
      // Mobile or user is at top of page
      header.setAttribute('data-scrolldown', 'false');
    }
  });
}

const HandleResize = () => {
  if (typeof window !== 'undefined') {
    // Run on load:
    handleResizeFixedHeader();

    window.addEventListener('resize', function () {
      // Need to handle this after each resize as well:
      handleResizeFixedHeader();
    });
  }
}

const RemoveCurrentFocus = () => {
  // Clear focus
  if (typeof document?.activeElement !== 'undefined') {
    (document.activeElement as HTMLElement).blur();
  }
}

const CloseDesktopNav = () => {
  if (typeof window !== 'undefined' && window.innerWidth > 900) {
    let navPanels = document.querySelectorAll(`div[class*='NavPanel_container'`);
    navPanels.forEach(navPanel => {
      // add class to remove focus
      navPanel.classList.add('hide');
      RemoveCurrentFocus();
      // remove class to get back old styles
      setTimeout((function() {
        navPanel.classList.remove('hide');
      }), 100);
    });
  }
}
const ToggleMobileNavItem = (e) => {
  if (typeof window !== 'undefined' && window.innerWidth <= 900) {
    let navItem = e.target.closest('[data-mobilenavitemopen]');
    let currentState = navItem.getAttribute('data-mobilenavitemopen') === 'true';
    navItem.setAttribute('data-mobilenavitemopen', !currentState);
  }
}

const ResetNav = () => {
  // If desktop, close nav
  CloseDesktopNav();

  // If mobile, close nav
  ToggleMobileNav();
}

const ToggleInfoDropdown = () => {
  let dropdownContainer = document.querySelector('*[data-infodropdownisopen');
  let currentState = dropdownContainer.getAttribute('data-infodropdownisopen') === 'true';
  // @ts-ignore
  dropdownContainer.setAttribute('data-infodropdownisopen', !currentState);
  dropdownContainer.setAttribute('aria-expanded', `${!currentState}`);

  if (!currentState) {
      // Is open
      document.body.addEventListener('click', clickToCloseDropdown);
      document.body.addEventListener('keyup', keyToCloseDropdown);
  }
  else {
      // Is closed
      document.body.removeEventListener('click', clickToCloseDropdown);
      document.body.removeEventListener('keyup', keyToCloseDropdown);
  }
}

const keyToCloseDropdown = (e) => {
  // Escape || Tab outside dropdown
  if (e.which === 27 || (e.which === 9 && e.target.closest('[data-infodropdownisopen]') === null)) {
      ToggleInfoDropdown();
  }
}

const clickToCloseDropdown = (e) => {
  if (!e.target.classList.contains(css.infoDropdownButton)) {
      ToggleInfoDropdown();
  }
} 

// check the current and related targets of the event
// and if we tabbed out of the search flyout close it.
const ToggleSearchFlyout2 = (event) => {
  
  if (event.currentTarget && event.relatedTarget) {

    const currentTargetId = event.currentTarget.id;
    const relatedTargetId = event.relatedTarget.id;
    const activeElementTag = document.activeElement.tagName;

    if(!(activeElementTag === "BODY" && currentTargetId === "searchFlyout" && (
      relatedTargetId === "searchFlyoutIcon" || 
      relatedTargetId === "searchBar" || 
      relatedTargetId === "searchBarSubmit" || 
      relatedTargetId === "searchFlyoutClose"
    ))){
      ToggleSearchFlyout();
    }
  }
};

const ToggleSearchFlyout = () => {
  let currentState = document.body.getAttribute('data-searchopen') === 'true';
  // @ts-ignore
  document.body.setAttribute('data-searchopen', !currentState);
  
  //adjust the aria-expanded attribute for the search icon button
  document.getElementById("searchFlyoutIcon").setAttribute('aria-expanded',Boolean(!currentState).toString());

  // Update tabindexes for keyboard tabbing, -1 is 'not tabbable' when search form is closed, 0 is 'tabbable' when open
  let allSearchActions = document.body.querySelectorAll(`div[class*='EduBrandBar_searchFlyout'] *[tabindex]`);
  allSearchActions.forEach(function (action) {
      action.setAttribute('tabIndex', currentState ? '-1' : '0');
  });
}


const GeneralHeader = (props) => {
  
  const { fields, history, sitecoreContext } = props;
  // @ts-ignore
  const [resetKey, setResetKey] = useReducer(() => Math.random(), Math.random());
  const [searchQuery, setSearchQuery] = useState('');
  const children = fields?.children ? fields?.children : [null, null];
  const [brandBar, navigation] = children;
  const utilityNavLinks = brandBar?.fields?.children;
  const navList = navigation.fields
  const siteLogo = fields?.siteLogo?.value?.src ? mediaApi.updateImageUrl(fields.siteLogo.value.src.split('?')[0]) : "";
  const siteName = fields.siteName.value;
  const seachIcon = fields.searchIcon.value;
  const searchPageLink = fields.searchPageLink?.value?.href;
  const globalSearchboxPlaceholderText = fields.globalSearchboxPlaceholderText.value;
  // const navigationFields = navigation?.fields;
  const isEditing = sitecoreContext && (sitecoreContext.pageEditing == true || sitecoreContext.pageState == 'preview'); 
  const hasChildren = fields?.children?.length > 0;

  

  const handleSearch = () => {
    if (fields.searchPageLink?.value?.href) {
        history.push(`${fields.searchPageLink.value.href}#q=${searchQuery}`);
    }
}
  const handleChange = (e) => {
    setSearchQuery(e.target.value)
  }
//Updating the useEffect to run the HandleResize whenever there is change in GeneralHeader component as part of EWP bugs-1-Alert-Banner-Display
  useEffect(() => {
    if (typeof window !== 'undefined' && !isEditing) {
      HandleResize();
      HandleScroll();
    }
  });

  return (
    <header key={`generalHeader-${resetKey}`}
      className={`${css.container} ${isEditing ? css.isEditing : ''}`} id='header'
      data-mobilenavisopen={false}
      data-scrolldown={false}>
     
<a href="#maincontent" className={css.skipLink}>Skip to main content</a>

{/* BrandBar */}

  <GeneralBrandbar
    phoenixLink={fields.phoenixLink} 
    phoenixCaption={fields.phoenixCaption} 
    phoenix ={fields.phoenix}
    utilityNavLinks = {utilityNavLinks}
    seachIcon = {seachIcon}
    searchPageLink = {searchPageLink}
    globalSearchboxPlaceholderText = {globalSearchboxPlaceholderText}
    handleChange = {''}
    ResetNavHandler = {setResetKey}

  />
{/* Flyout Search */}
<div className={css.searchFlyout} id='searchFlyout' aria-labelledby='searchFlyoutIcon' onBlur={ToggleSearchFlyout2}>
                  <form className={css.searchForm} data-formtype='search' onSubmit={handleSearch}>
                      <div className={css.searchBarContainer}>
                          <label htmlFor='searchBar' className={css.searchBarLabel}>Search</label>
                          <input id='searchBar'
                              className={css.searchBar}
                              type='search'
                              aria-label='search'
                              placeholder={globalSearchboxPlaceholderText}
                              tabIndex={-1}
                              onChange={handleChange}
                              onFocus={(e) => e.target.placeholder = ''}
                              onBlur={(e) => e.target.placeholder = globalSearchboxPlaceholderText}
                              value={searchQuery} 
                              />
                      </div>
                      <div className='fa fa-search'>
                          <input 
                            id="searchBarSubmit"
                            type='submit' 
                            value='Search' 
                            tabIndex={-1} 
                             onSubmit={setResetKey}
                           />
                      </div>                      
                  </form>
                  <button 
                      id="searchFlyoutClose"
                      onClick={() => ToggleSearchFlyout()}
                      aria-label='Close search form'
                      className={`${css.close} fa fa-close`}
                      tabIndex={-1} />
              </div>
{/* Navbar */}

<NavigationInsert siteName={siteName} siteLogo={siteLogo} className={css.navigation} navList={navList} utilityNavLinks={utilityNavLinks} resetNavHandler={setResetKey} />

      <div id='maincontent' className={css.skipLinkAnchor}>Main content</div>
    </header>
  )
};



const NavigationInsert = ({siteName, siteLogo, className, navList, utilityNavLinks, resetNavHandler}) =>{
  return(
    <div  className={className} >
     <div className={css.navigationContent} data-navcontainer='true'>

      {
        siteLogo != "" && 
        <a className={css.siteHomeLink} href='/' style={{backgroundImage: `url(${siteLogo})`}}>
          {siteName ? siteName : 'The University of Chicago'} 
        </a>
      }
      {
        navList &&
        <GeneralNavigation fields={navList} ResetNavHandler={resetNavHandler} />
      }

      {
        utilityNavLinks &&
        <MobileUtilNav links={utilityNavLinks} ResetNavHandler={resetNavHandler} />
      }
     </div>
    </div>

  )
}


// Takes a list of links and spits out left/right container markup
const MobileUtilNav = ({ links, ResetNavHandler }) => {
  const closeSearchFlyout = () =>{
    let currentState = document.body.getAttribute('data-searchopen')
    
       if(currentState === 'true'){
        document.body.setAttribute('data-searchopen', 'false');
       }
    
     // Update tabindexes for keyboard tabbing, -1 is 'not tabbable' when search form is closed, 0 is 'tabbable' when open
    let allSearchActions = document.body.querySelectorAll(`div[class*='GeneralHeader_searchFlyout'] *[tabindex]`);
    allSearchActions.forEach(function (action) {
        action.setAttribute('tabIndex', currentState ? '-1' : '0');
    });
    ResetNavHandler();
}
  return (
    <nav  className={css.mobileLinkContainer} aria-label="utility">
           <ul>
          {
              links?.map((link, index) => (
                  (link?.fields?.title?.value && link?.fields?.children?.length > 0) ?
                      // Dropdown
                      <li className={`${css.infoDropdownContainer} ${css.linkListItem}`}
                          data-infodropdownisopen={false}
                          aria-expanded={false}
                          key={`brandBar-link-dropdown-${index}`}>
                          <Text className={css.infoDropdownButton}
                              field={link.fields.title}
                              tag='button'
                              onClick={ToggleInfoDropdown}
                               />
                          <ul className={css.infoDropdownList}>
                              {
                                  link.fields.children?.map((dropdownLink, index) =>
                                      (dropdownLink?.fields?.link?.value?.href && dropdownLink?.fields?.linkText?.value) &&
                                      <li className={css.infoDropdownListItem} key={`infodropdown-${index}`}>
                                          <RoutableLink field={dropdownLink.fields.link}
                                              data-chevron={true} data-size={Sizes.SMALL}
                                              data-color={Colors.GREY}
                                              onClick={()=>closeSearchFlyout()}
                                              className={css.infoDropdownLink}>
                                                
                                              <Text field={dropdownLink.fields.linkText} />
                                          </RoutableLink>
                                      </li>
                                  )
                              }
                          </ul>
                      </li>
                      :
                      // Regular link
                      (link?.fields?.link?.value?.href && link?.fields?.linkText?.value) &&
                      <li className={css.linkListItem} key={`brandBar-link-dropdown-${index}`}>
                          <RoutableLink field={link.fields.link}
                             onClick={()=>closeSearchFlyout()}
                              className={`${css.brandBarLink}${link.fields.highlight?.value === true ? ` ${css.linkHighlight}` : ''}`}
                              key={`brandBar-link-${index}`}>
                              <Text field={link.fields.linkText} />
                          </RoutableLink>
                      </li>
              ))
          }
      </ul>
  
    </nav>
 )
}

export default withRouter(withSitecoreContext()(GeneralHeader)); 